(function () {
  'use strict';

  // Event name Tag Assistant / other CMP sites show in the Summary list
  var EVENT_NAME = 'consent_status';

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  function toGtag(allowed) {
    return allowed ? 'granted' : 'denied';
  }

  function normalizeDetail(detail) {
    detail = detail || {};

    // Shopify banner detail uses *Allowed booleans.
    // Stored consent API uses analytics/marketing/preferences: 'yes' | 'no' | ''.
    function readBool(keys) {
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!Object.prototype.hasOwnProperty.call(detail, key)) continue;
        var value = detail[key];
        if (value === true || value === 'yes' || value === 'granted' || value === 'allow') {
          return true;
        }
        if (value === false || value === 'no' || value === 'denied' || value === 'deny') {
          return false;
        }
      }
      return false;
    }

    var analytics = readBool([
      'analyticsAllowed',
      'analyticsProcessingAllowed',
      'analytics'
    ]);
    var marketing = readBool([
      'marketingAllowed',
      'firstPartyMarketingAllowed',
      'thirdPartyMarketingAllowed',
      'marketing'
    ]);
    var preferences = readBool([
      'preferencesAllowed',
      'preferencesProcessingAllowed',
      'preferences'
    ]);
    var saleOfData = Object.prototype.hasOwnProperty.call(detail, 'saleOfDataAllowed')
      || Object.prototype.hasOwnProperty.call(detail, 'sale_of_data')
      ? readBool(['saleOfDataAllowed', 'sale_of_data'])
      : marketing;

    return {
      analytics: analytics,
      marketing: marketing,
      preferences: preferences,
      saleOfData: saleOfData
    };
  }

  function consentState(normalized) {
    var allAllowed = normalized.analytics && normalized.marketing && normalized.preferences;
    var allDenied = !normalized.analytics && !normalized.marketing && !normalized.preferences;

    return {
      status: allAllowed ? 'granted' : allDenied ? 'denied' : 'mixed',
      accepted: allAllowed,
      declined: allDenied
    };
  }

  function applyRedactionSettings(normalized) {
    // Same commands other sites show in Tag Assistant Summary:
    // set.ads_data_redaction (gtag) / set.url_passthrough (gtag)
    var adsDenied = !normalized.marketing;
    gtag('set', 'ads_data_redaction', adsDenied);
    gtag('set', 'url_passthrough', true);
  }

  function applyGtagConsent(command, normalized) {
    gtag('consent', command, {
      analytics_storage: toGtag(normalized.analytics),
      ad_storage: toGtag(normalized.marketing),
      ad_user_data: toGtag(normalized.marketing),
      ad_personalization: toGtag(normalized.marketing),
      functionality_storage: toGtag(normalized.preferences),
      personalization_storage: toGtag(normalized.preferences),
      security_storage: 'granted'
    });
  }

  function pushConsentStatus(normalized, action) {
    var state = consentState(normalized);

    window.dataLayer.push({
      event: EVENT_NAME,
      consent_action: action || 'stored',
      consent_status: state.status,
      consent_accepted: state.accepted,
      consent_declined: state.declined,
      analytics_storage: toGtag(normalized.analytics),
      ad_storage: toGtag(normalized.marketing),
      ad_user_data: toGtag(normalized.marketing),
      ad_personalization: toGtag(normalized.marketing),
      functionality_storage: toGtag(normalized.preferences),
      personalization_storage: toGtag(normalized.preferences),
      sale_of_data: toGtag(normalized.saleOfData),
      shopify_consent: {
        analyticsAllowed: normalized.analytics,
        marketingAllowed: normalized.marketing,
        preferencesAllowed: normalized.preferences,
        saleOfDataAllowed: normalized.saleOfData
      }
    });
  }

  function syncConsent(detail, action, gtagCommand) {
    var normalized = normalizeDetail(detail);
    applyRedactionSettings(normalized);
    applyGtagConsent(gtagCommand || 'update', normalized);
    pushConsentStatus(normalized, action);
  }

  // Match Tag Assistant order used by other sites:
  // set.* → consent.default → (later) consent.update → consent_status
  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);

  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted',
    wait_for_update: 2000
  });

  function readCurrentConsent(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;

    var current = api.currentVisitorConsent() || {};
    var hasDecision = !!(
      current.analytics ||
      current.marketing ||
      current.preferences ||
      current.sale_of_data
    );

    if (!hasDecision) return null;

    return {
      analytics: current.analytics,
      marketing: current.marketing,
      preferences: current.preferences,
      sale_of_data: current.sale_of_data
    };
  }

  function onApiReady(api) {
    var stored = readCurrentConsent(api);
    if (stored) {
      syncConsent(stored, 'stored', 'update');
    }
  }

  function onVisitorConsent(event) {
    syncConsent((event && event.detail) || {}, 'new', 'update');
  }

  // Shopify fires this when Accept / Decline is chosen
  document.addEventListener('visitorConsentCollected', onVisitorConsent);
  window.addEventListener('visitorConsentCollected', onVisitorConsent);

  function loadCustomerPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      onApiReady(window.Shopify.customerPrivacy);
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        onApiReady(window.Shopify.customerPrivacy);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCustomerPrivacy);
  } else {
    loadCustomerPrivacy();
  }
})();
